<template>
  <div>
    <!--<div class="m-b-20 ovf-hd ovf-hd fr"> 去掉fr修改按钮位置错误-->
    <!--<div class="m-b-20 ovf-hd ovf-hd" v-if="isShow">-->
    <div class="ovf-hd" style="min-width: 60px;" v-if="isShow">
      <img :src="bigImg" alt="" class="bigImg" v-if="isHoverShow">
      <div class="fl" style="width:calc(100% - 150px)">
        <slot name="header-left"></slot>
      </div>
      <div class="fr">
        <slot name="header-right"></slot>
      </div>
      <!-- <div style="clear:both"></div> -->
    </div>
    <div class="ovf-hd" style="width:100%;">
      <slot name="header-left-screening"></slot>
    </div>
    <el-table 
      border
      :data="tableData"
      style="width: 100%"
      @selection-change="selectItem"
      @sort-change="sortTable"
      :row-class-name="tableRowClassName">
      <el-table-column
        type="selection"
        :context="_self"
        width="50">
      </el-table-column>
      <el-table-column
        label="序号"
        v-if="hasOrder">
        <template scope="scope">
          {{ getOrder(scope.$index) }}
        </template>
      </el-table-column>
      <el-table-column 
      v-for="(col, cindex) in column"
      :prop="col.field_name"
      :label="col.show_name" 
      :width="getWidth(col)"
      :sortable="col.is_sort == 1 ? 'custom' : false"
      v-if="col.is_visible != 0"
      :fixed='isFixed(cindex)'>
        <template v-if="col.children">
          <el-table-column 
            v-for="(childCol, childIndex) in col.children"
            :prop="childCol.field_name"
            :label="childCol.show_name"
            :width="getWidth(childCol)"
            :sortable="childCol.is_sort == 1 ? 'custom' : false"
            v-if="childCol.is_visible != 0"
            :fixed='isFixed(childIndex)'>
            <template scope="scope">
              <list-col
                :col="childCol"
                :row="scope.row"
                :index="scope.$index"
                @jumpPage="jumpPage"
                @downloadItem="downloadItem"
                @sendParams="sendParams"
                @showRelate="showRelate"
                @enterImg="enterImg"
                @leaveImg="leaveImg">
              </list-col>
            </template>
          </el-table-column>
        </template>
        <template scope="scope" v-if="!col.children">
          <list-col
            :col="col"
            :row="scope.row"
            :index="scope.$index"
            @jumpPage="jumpPage"
            @downloadItem="downloadItem"
            @sendParams="sendParams"
            @showRelate="showRelate"
            @enterImg="enterImg"
            @leaveImg="leaveImg">
          </list-col>
        </template>
      </el-table-column>
      <el-table-column label="" v-if="!column || !column.length">
      </el-table-column>
      <el-table-column label="操作" :width="operationCount * 100" v-if="operationCount">
        <template scope="scope">
          <slot name="table" :row="scope.row"></slot>
        </template>
      </el-table-column>
    </el-table>
    <div class="m-t-20 m-b-20 ovf-hd">
      <div class="fl">
        <slot name="footer"></slot>
      </div>
      <div class="fr">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            layout="total, sizes, prev, pager, next"
            :page-sizes="pageSizes"
            :page-size="currentSize"
            :current-page="currentPage"
            :total="total">
        </el-pagination>
      </div>
      <div style="clear:both"></div>
    </div>
  </div>
</template>

<script>
  /**
   * @author duoremix
   * @param Number index 列表的索引值
   * @param Array tableData 列表数据
   * @param Array column 列表所显示列数据
   * @param Number pageCount 总页数
   * @param Number total 数据总条数
   * @param Array pageSizes 一页数据数量（数组），例：[10, 20, 30]
   * @param Number currentPage 当前页码
   * @param Number currentSize 当前一页数据数量
   * @param Boolean hasOrder 是否显示序号
   * @param Number operationCount 列表内操作数量
   */
  import cmsConfig from '../../../config/cmsConfig'
  import listCol from './listCol'

  export default {
    name: 'listTable',
    props: {
      index: {  // 列表的索引值
        type: Number,
        default() {
          return -1
        }
      },
      tableData: {  // 列表数据
        type: Array,
        default() {
          return []
        }
      },
      column: {  // 列表所显示列数据
        type: Array,
        default() {
          return []
        }
      },
      pageCount: {  // 总页数
        type: Number,
        default() {
          return 0
        }
      },
      total: {  // 总条数
        type: Number,
        default() {
          return 0
        }
      },
      pageSizes: {  // 一页数据数量（数组），例：[10, 20, 30]
        type: Array,
        default() {
          return [15]
        }
      },
      freezeColumn: {  // 冻结列表列数
        type: Number,
        default() {
          return 0
        }
      },
      currentPage: {  // 当前页码
        type: Number,
        default() {
          return 1
        }
      },
      currentSize: {  // 当前一页数据数量
        type: Number,
        default() {
          return 15
        }
      },
      hasOrder: { // 是否显示序号
        type: Boolean,
        default() {
          return false
        }
      },
      operationCount: { // 列表内操作数量
        type: Number,
        default() {
          return 0
        }
      },
      isShow: { // 控制按钮层是否显示
        type: Boolean,
        default() {
          return false
        }
      }
    },
    data() {
      return {
        windowWidth: 0,
        leftMenuWidth: 230,
        windowPadding: 40,
        bigImg: '',
        isHoverShow: false
      }
    },
    created() {
      let windowWidth = window.innerWidth - this.leftMenuWidth - this.windowPadding
      this.windowWidth = windowWidth > 1200 ? windowWidth : 1200
    },
    methods: {
      enterImg(img, flag) {
        this.bigImg = img
        this.isHoverShow = flag
      },
      leaveImg() {
        this.bigImg = ''
      },
      isFixed (index) {
        if (index < this.freezeColumn) {
          return true
        } else {
          return false
        }
      },
      getOrder(index) {
        return (this.currentPage - 1) * this.currentSize + index + 1
      },
      selectItem(value) {
        this.$emit('selectChange', value)
      },
      sortTable(sort) {
        let sortType = ''
        if (sort.order == 'ascending') {
          sortType = 'asc'
        } else if (sort.order == 'descending') {
          sortType = 'desc'
        }
        this.$emit('sortTable', sort.prop, sortType)
      },
      tableRowClassName(row, $index) {
        let className = ''
        if (row.style_type == this.ROW_STYLE_TYPE_BBBC) {
          className = 'ROW_STYLE_TYPE_BBBC'
        }
        if (row.style_type == this.ROW_STYLE_TYPE_BBRC) {
          className = 'ROW_STYLE_TYPE_BBRC'
        }
        if (row.style_type == this.ROW_STYLE_TYPE_RBWC) {
          className = 'ROW_STYLE_TYPE_RBWC'
        }
        return className
      },
      handleCurrentChange(currentPage) {  // 换页
        this.$emit('handleCurrentChange', currentPage)
      },
      handleSizeChange(size) {  // 切换一页数据数量
        this.$emit('handleSizeChange', size)
      },
      downloadItem(col, rowIndex) { // 列数据的下载操作
        this.$emit('downloadItem', col, this.tableData[rowIndex])
      },
      jumpPage(col, rowIndex) { // 页面跳转
        this.$emit('jumpPage', col, this.tableData[rowIndex])
      },
      sendParams(col, rowIndex) { // 传参给同页一级功能集
        this.$emit('sendParams', col, this.tableData[rowIndex])
      },
      showRelate(col, rowIndex) {
        this.$emit('showRelate', col, this.tableData[rowIndex])
      },
      getWidth(col) {
        let width = ''
        if (col.width && this.windowWidth) {
          width = `${col.width / 12 * this.windowWidth}`
        }
        return width
      }
    },
    components: {
      listCol
    },
    mixins: [cmsConfig]
  }
</script>
<style>
  .imgContent{
    display:inline-block;
    position: relative;
    padding:5px 0;
  }
  .isShowBig{
    cursor: pointer;
  }
  .imgContent:hover .bigImg{
    display:block;
  }
  .bigImg{
    position: absolute;
    z-index: 99999;
    left: 20px;
    top: 77px;
  }
  .ROW_STYLE_TYPE_BBBC{ /*蓝底黑字*/
    background: #1AA3FA !important;
    color: #333 !important;
  }
  .ROW_STYLE_TYPE_BBRC{ /*蓝底红字*/
    color: #FF2235 !important;
    background: #1AA3FA !important;
  }
  .ROW_STYLE_TYPE_RBWC{ /*红底白字*/
    color: #fff !important;
    background: #FF2235 !important;
  }
</style>


// WEBPACK FOOTER //
// listTable.vue?5bb8fcf1